<template>
  <el-dialog
    class="rc-dialog"
    title="选择审核人"
    :visible.sync="dialogVisible.flag"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    <el-tree
      class="filter-tree"
      :data="auditorData"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterNode"
      show-checkbox
      check-strictly
      check-on-click-node
      :expand-on-click-node="false"
      icon-class="-"
      node-key="uuid"
      @check-change="auditorCheckChange"
      ref="tree"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" @click="selectAuditor" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { userAuditorList } from "@/api/leaveAudit";
export default {
  data() {
    return {
      filterText: "",
      auditorData: [],
      defaultProps: {
        children: "children",
        label: "userName"
      },
      selectedAuditor: null
    };
  },
  props: {
    dialogVisible: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      }
    },
    deptId: {
      type: String,
      default: () => "",
    }
  },
  watch: {
    filterText(val) {
      this.$refs["tree"].filter(val);
    }
  },
  created() {
    userAuditorList(this.deptId).then(res => {
      if (!res || res.code != 0) return;
      this.auditorData = res.data;
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.userName.indexOf(value) !== -1;
    },
    auditorCheckChange(data, checked) {
      if (checked) {
        this.selectedAuditor = data;
        this.$refs["tree"].setCheckedKeys([data.uuid]);
      } else {
        this.selectedAuditor = null;
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    selectAuditor() {
      if (!this.selectedAuditor) {
        this.$message({
          message: "请选择审核员",
          type: "warning"
        });
      } else {
        this.$emit("didSelectAuditor", this.selectedAuditor);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
    .filter-tree {
      margin-top: 20px;
      max-height: 200px;
      border: 1px solid #d7dbe0;
      border-radius: 2px;
      overflow-y: auto;
    }
  }
}
</style>
